import { ToastContext } from ".";
import { useGenericContext } from "../../hooks";

export const useToasts = () => useGenericContext(ToastContext);
